export default "__VITE_ASSET__BlERBdJ6__"